import type { Messages } from '../de';

export default {
  kicker: 'More',
  title: 'Gear',
  loading: 'Loading …',
  loadError: 'Gear not loaded: {error}',
  active: 'Active',
  retired: 'Retired',
  empty: 'No shoes yet. Add one – or import your Strava export.',
  add: 'New shoe',
  edit: 'Edit',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  deleteConfirm: {
    one: 'Deleting removes the shoe from {count} activity. It then counts without shoes and won’t be asked about again. This can’t be undone – to keep the km, retire it instead.',
    other: 'Deleting removes the shoe from {count} activities. They then count without shoes and won’t be asked about again. This can’t be undone – to keep the km, retire it instead.',
  },
  deleteYes: 'Delete for good',
  retire: 'Retire',
  unretire: 'Bring back',
  retireHint: 'Retire: the shoe stays in the archive with its km, but is no longer offered and no longer warns.',
  unretireHint: 'Bring back: the shoe is offered again and warns again.',
  name: 'Name',
  namePlaceholder: 'e.g. HOKA Clifton 9',
  startKm: 'km before',
  startKmHelp: 'Already run before dashy-dash knew the shoe',
  warnKm: '“Replace soon” from km',
  limitKm: '“Replace” from km',
  limitHelp: 'Running shoes usually last 500–800 km. Empty = no limit.',
  noLimit: 'empty = none',
  counts: 'Counted: running, walking and hiking in the shoe, plus the km before.',
  uses: { one: '{count} activity', other: '{count} activities' },
  range: 'run {from} – {to}',
  ofStart: '{km} of it before',
  retiredOn: 'retired {date}',
  unused: 'not used yet',
  status: { warn: 'Replace soon', limit: 'Replace' },
  toWarn: '{km} left until “Replace soon” ({at})',
  toLimit: '{km} left until “Replace” ({at})',
  overLimit: '{km} over {at}',
  retiredShow: { one: 'Show retired ({count})', other: 'Show retired ({count})' },
  ask: {
    title: 'Ask after a run',
    sub: 'When a new run has no shoes, “Today” asks – by push too, if you like.',
    on: 'On',
    off: 'Off',
  },
  push: {
    title: 'Push on this device',
    on: 'Turn off',
    off: 'Turn on',
    sub: 'After a new run without shoes you get a message, nothing else.',
    test: 'Test message',
    testSent: 'Sent.',
    devices: { one: '{count} device registered', other: '{count} devices registered' },
    unsupported: 'This browser can’t receive push messages.',
    install: 'On iPhone, push only works once dashy-dash is installed (see above).',
    denied: 'Notifications are blocked in the browser – allow them in the site settings.',
    hint: 'Android shows the two most recently used shoes as buttons in the message; on iPhone a tap opens the card.',
  },
  install: {
    title: 'Install as an app',
    button: 'Install',
    prompt: 'Then it starts like an app, without the address bar.',
    done: 'Installed – open it from the new icon from now on.',
    ios1: 'In Safari, tap “Share” in the bar at the bottom:',
    ios2: 'Choose “Add to Home Screen” in the list (you may need to swipe down a bit).',
    ios3: 'Tap “Add” at the top right.',
    ios4: 'Open dashy-dash from the new icon. Then turn on push for the shoe question under “Gear”.',
    cardTitle: 'dashy-dash as an app',
    why: 'On the home screen dashy-dash starts like an app, without the address bar – and can ask about your shoes by push after a run.',
    dismiss: 'Don’t show again',
    shareIcon: 'Share icon: square with an arrow pointing up',
    android: 'In Chrome, tap ⋮ at the top right, then “Install app” or “Add to Home screen”. Push also works without it, right in the browser.',
    desktop: 'In Chrome or Edge, click the install icon on the right of the address bar; in Safari on a Mac, File → “Add to Dock”.',
  },
  prompt: {
    title: 'Which shoes?',
    skip: 'No shoes',
    later: 'Ask later',
    more: { one: 'Then the card asks about {count} more run.', other: 'Then the card asks about {count} more runs.' },
    otherAnswers: 'Or:',
    saved: '{name} saved',
  },
  activity: {
    label: 'Shoes',
    none: 'None',
    manage: 'Gear',
  },
} satisfies Messages['gear'];
